<script lang="ts">
	export let fill = "#f66d6c";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 20 20">
	<g>
		<g>
			<path
				d="M547.333 278.005a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 19.2a9.2 9.2 0 1 1 9.2-9.2 9.212 9.212 0 0 1-9.2 9.195z"
				transform="translate(-537.333 -278.005)"
				style={`fill:${fill}`} />
		</g>
		<g>
			<g>
				<path
					d="M559.53 300.6a.4.4 0 0 1-.281-.116l-8.569-8.545a.4.4 0 1 1 .562-.563l8.569 8.545a.4.4 0 0 1-.281.68z"
					transform="translate(-545.247 -285.936)"
					style={`fill:${fill}`} />
			</g>
			<g>
				<path
					d="M550.991 300.6a.4.4 0 0 1-.282-.679l8.545-8.569a.4.4 0 1 1 .563.562l-8.545 8.569a.4.4 0 0 1-.281.117z"
					transform="translate(-545.265 -285.918)"
					style={`fill:${fill}`} />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
</style>
